import React from "react";
import {Container, Content, ContainerChips, Chip, ChipText, ChipRemoveIcon} from "./styled";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import LabelInput from "@dropDesk/presentation/components/inputs/input_with_border/label";
import {Tooltip} from "antd";
import DropDeskIcon from "@dropDesk/storage/icons";
import {ContentButtons, ContentLabel} from "@dropDesk/presentation/components/inputs/input_with_border/styled";
import ButtonTopTwo from "@dropDesk/presentation/components/inputs/input_with_border/button_top_two";
import ButtonTopOne from "@dropDesk/presentation/components/inputs/input_with_border/button_top_one";
import LeftIcon from "@dropDesk/presentation/components/inputs/input_with_border/left_icon";
import RemoveFilter from "@dropDesk/presentation/components/inputs/input_with_border/remove_filter";
import RightIcon from "@dropDesk/presentation/components/inputs/input_with_border/right_icon";
import MessageError from "@dropDesk/presentation/components/inputs/input_with_border/message_error";
import {InputChipProps} from "@dropDesk/presentation/components/inputs/input_chips/input_chips_border";


export default function InputChips(props: InputChipProps) {

    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;
    const useBorder = props.usedBorder !== false;

    const renderChips = (): React.ReactNode => {
        if (!props.chips || props.chips.length === 0) {
            return null;
        }

        return props.chips.map((chip) => (
            <Chip
                key={chip.id}
                background={colors.tertiary}
                border={colors.border}
            >
                <ChipText color={colors.text}>
                    {chip.description}
                </ChipText>
                {props.onRemoveChip && !props.disabled && (

                    <ChipRemoveIcon
                        color={colors.text}
                        background={colors.buttonOnBackground}
                        accent={colors.accent}
                        onClick={(e) => {
                            e.stopPropagation();
                            props.onRemoveChip?.(chip.id);
                        }}
                    >
                        <DropDeskIcon
                            icon={ICONS_DROPDESK.close}
                            size={12}
                        />
                    </ChipRemoveIcon>
                )}
            </Chip>
        ));
    }

    return (

        <Container marginLeft={props.marginLeft ?? 0} marginTop={props.marginTop ?? 0}>
            <ContentLabel
                style={{justifyContent: props.useInformationIcon ? 'flex-start' : 'space-between'}}>
                {!!props.label && <LabelInput required={props.required} label={props.label}/>}
                {props.useInformationIcon &&

                    <Tooltip placement={'top'} title={props.tooltipInformation ?? ''}>
                        <>
                            <DropDeskIcon
                                icon={ICONS_DROPDESK.info}
                                style={{marginLeft: 3, pointerEvents: 'none'}}
                                color={colors.hint}
                            />
                        </>
                    </Tooltip>}

                <ContentButtons>
                    {props.useTwoButtonRight &&
                        <ButtonTopTwo
                            tooltipTwoButtonRight={props.tooltipTwoButtonRight}
                            onClickTwoButtonRight={props.onClickTwoButtonRight}
                            disabledButtonRight={props.disabledButtonRight}
                            nameIconButtonRight={props.nameIconButtonRight}
                            labelTwoButtonRight={props.labelTwoButtonRight}
                        />
                    }

                    {props.useButtonRight &&
                        <ButtonTopOne
                            tooltipButtonRight={props.tooltipButtonRight}
                            onClickButtonRight={props.onClickButtonRight}
                            disabledButtonRight={props.disabledButtonRight}
                            nameIconButtonRight={props.nameIconButtonRight}
                            labelButtonRight={props.labelButtonRight}
                        />}
                </ContentButtons>
            </ContentLabel>

            <Content
                onClick={props.onClick && !props.disabled ? props.onClick : () => {
                }}
                background={props.backgroundColor ?? colors.backgroundInput}
                usedBorder={useBorder}
                size={props.size}
                accent={colors.accent}
                disabled={props.disabled ?? false}
                border={colors.border}
            >

                {props.nameIconLeft &&
                    <LeftIcon
                        nameIconLeft={props.nameIconLeft}
                        iconLeftIsMain={props.iconLeftIsMain}
                        onClickLeftIcons={props.onClickLeftIcons}
                        sizeLeftIcons={props.sizeLeftIcons}
                        disabled={props.disabled}
                    />}
                <ContainerChips>
                    {renderChips()}
                </ContainerChips>

                {props.useRemoveFilter && !props.disabled &&
                    <RemoveFilter
                        onClickRemoveFilter={props.onClickRemoveFilter}
                    />}

                {props.nameIconRight && (
                    <RightIcon
                        disabled={props.disabled}
                        readOnly={props.readOnly}
                        onClick={props.onClick}
                        onClickRightIcons={props.onClickRightIcons}
                        size={props.size}
                        nameIconRight={props.nameIconRight}
                        sizeRightIcons={props.sizeRightIcons}
                        tooltilRightIcon={props.tooltilRightIcon}
                    />
                )}


            </Content>

            {(!!props.messageError || props.messageError === "") &&
                <MessageError messageError={props.messageError}/>}


        </Container>
    )
}
